export default "__VITE_ASSET__CshNUPaJ__"